<template>
  <div class="row_center_around w-full shrink-0">
    <button
      class="row_center_center"
      v-for="(item, index) in buttonItems"
      :key="index"
      :class="currentTabIndex === index ? 'tabed' : 'tab'"
      @click="setCurrentTab(index)"
    >
      <p>{{ item.name }}</p>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    buttonItems: {
      type: Array,
      default: () => [],
      required: true,
    },
    currentTabIndex: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  methods: {
    setCurrentTab(index) {
      this.$emit("setCurrentTab", index);
    },
  },
};
</script>
<style lang="scss" scoped>

button {
  flex-shrink: 0;
  padding: 0px 22px;
  border-radius: 30px;
  background-color: #fff;
  color: #666666;
  border: none;
  height: 42px;
  font-weight: 700;
  font-size: 16px;
  margin: 0 3px;
}
.tabed {
  color: #000;
  background-color: #FBCB02;
  flex-shrink: 0;
}
</style>
